'use client';

import { createContext, ReactNode, useContext, useEffect, useState } from "react";
import { Contact } from "../lib/generated/graphql-types";
import { getContactCached } from "@/app/lib/contact/queries";

interface ContactContextType {
    content: Contact | undefined;
    isLoading: boolean;
}

const ContactContext = createContext<ContactContextType | undefined>(undefined);

export function useContact() {
    const context = useContext(ContactContext);
    if (!context) {
        throw new Error("useContact must be used within a ContactProvider");
    }
    return context;
}

export function ContactProvider({ children }: { children: ReactNode }) {

    const [data, setData] = useState<Contact | undefined>(undefined);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const { data, error } = await getContactCached();

                if (error) throw error;

                setData(data);
            } catch (error) {
                console.error("Error fetching contact data:", error);
            } finally {
                setIsLoading(false);
            }
        }

        fetchData();
    }, []);

    return (
        <ContactContext.Provider
            value={{
                isLoading,
                content: data
            }}
        >
            {children}
        </ContactContext.Provider>
    );
}
